const ActiveItemClaimPrizeButton = ({icon, text, claimPrizeHandler}) => {
  return (
    <button
        className="card-details__button card-details__button--craft"
        onClick={claimPrizeHandler}
      >
        <img src={icon} alt="" />
        {text}
      </button>
  )
}

export default ActiveItemClaimPrizeButton
